import React, { FC, ReactNode } from 'react';
import styles from './ContractsFilterContainer.module.scss';

export interface FilterContainerProps {
  children: ReactNode;
  className?: string;
}

export const ContractsFilterContainer: FC<FilterContainerProps> = ({
  children,
  className,
}) => {
  return <div className={`${styles.container} ${className || ''}`}>{children}</div>;
};
